import Loader from "react-loaders";
import {connect} from "react-redux";
import {loadUser} from "actions/auth";
import {ToastContainer} from "react-toastify";
import Error404 from "../../pages/Auth/Error404";
import "react-toastify/dist/ReactToastify.min.css";
import PrivateRoute from "../../common/PrivateRoute";
import {getNotification} from "actions/notification";
import React, {Suspense, lazy, Fragment} from "react";
import {UserRoleValues} from "assets/values/constants";
import {Route, Redirect, withRouter} from "react-router-dom";

const DataPages = lazy(() => import("pages/Data"));
const AuthPages = lazy(() => import("../../pages/Auth"));
const TestPages = lazy(() => import("../../pages/Tests"));
const OrderPages = lazy(() => import("../../pages/Orders"));
const ReportPages = lazy(() => import("../../pages/Reports"));
const ReturnPages = lazy(() => import("../../pages/Returns"));
const FinancePages = lazy(() => import("../../pages/Finance"));
const SettingPages = lazy(() => import("../../pages/Settings"));
// const SupportPages = lazy(() => import("../../pages/Support"));
const DashboardPages = lazy(() => import("../../pages/Dashboard"));
const CustomersPages = lazy(() => import("../../pages/Customers"));
const DevelopmentPages = lazy(() => import("../../pages/Development"));

const AppMain = ({auth}) => {
    return (
        <Fragment>
            {/* Users */}
            <Suspense
                fallback={
                    <div className="loader-container">
                        <div className="loader-container-inner">
                            <div className="text-center">
                                <Loader active type="ball-pulse-rise"/>
                            </div>
                        </div>
                    </div>
                }
            >
                <PrivateRoute exact path="/">
                    <Redirect
                        to={auth.user && auth.user.role === UserRoleValues.SUPPLIER_ADMIN ? "/dashboard" : "/orders/orders"}
                    />
                </PrivateRoute>
                <Route path="/auth" component={AuthPages}/>
                <Route path="/error" component={Error404}/>
                <PrivateRoute path="/data" component={DataPages}/>
                <PrivateRoute path="/tests" component={TestPages}/>
                <PrivateRoute path="/orders" component={OrderPages}/>
                <PrivateRoute path="/returns" component={ReturnPages}/>
                <PrivateRoute path="/reports" component={ReportPages}/>
                <PrivateRoute path="/finance" component={FinancePages}/>
                <PrivateRoute path="/settings" component={SettingPages}/>
                <PrivateRoute path="/dashboard" component={DashboardPages}/>
                <PrivateRoute path="/customers" component={CustomersPages}/>
                <PrivateRoute path="/development" component={DevelopmentPages}/>
                {/* <PrivateRoute path="/support" component={SupportPages} /> */}
            </Suspense>
            <ToastContainer
                position="bottom-center"
            />
        </Fragment>
    );
};

const mapStateToProps = (state) => ({
    auth: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
    loadUser: () => dispatch(loadUser()),
    getNotification: () => dispatch(getNotification()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(AppMain));
